export const basePathClient = process.env.REACT_APP_BASE_PATH_CLIENT;



// WEBPACK FOOTER //
// ./src/helper/basePathClient.jsx